import React, {useEffect, useRef, useState} from 'react';
import cl from '../BaseSimplePage/BaseSimpleItemEditor.module.css'
import ServerManager from "../../API/ServerManager";
import {Alert, LinearProgress} from "@mui/material";
import SurveysItemForm from "./SurveysItemForm";
import SurveysItemEditorHeader from "./SurveysItemEditorHeader";

const SurveysItemEditor = ({
                                    surveyData,
                                    editItemId,
                                    searchByIdMode,
                                }) => {

    const [isLoading, setIsLoading] = React.useState(true);
    const [errorMessage, setErrorMessage] = React.useState("");
    const [formData, setFormData] = useState(null);
    const formControlRef = useRef(null);

    // получение данных с сервера (если режим редактирования) (один раз)
    useEffect(() => {
        async function fetch() {
            setIsLoading(true);
            setFormData(null);
            try {
                const itemData = await ServerManager.getSimpleModeItem("survey/response", editItemId);
                if (!ignore) {
                    setFormData(itemData);
                }
            } catch (error) {
                if (!ignore) {
                    if (searchByIdMode)
                        setErrorMessage(`Запись с ID=${editItemId} не найдена`);
                    else
                        setErrorMessage(`Ошибка при загрузке данных: ${error}`);
                }
            } finally {
                if (!ignore) setIsLoading(false);
            }
        }

        let ignore = false;
        fetch();
        return () => {
            ignore = true;
        }
    }, []);

    return (
        <div className={cl.main}>
            <SurveysItemEditorHeader
                editItemId={editItemId}
            />
            <div className={cl.scrollContent}>
                {isLoading && <LinearProgress/>}
                {!isLoading && errorMessage && <Alert variant="outlined" severity="error">{errorMessage}</Alert>}
                {!isLoading && !errorMessage && <SurveysItemForm
                    surveyData={surveyData}
                    initData={formData}
                    controlRef={formControlRef}
                    pageOptions={{}}
                />}
            </div>
        </div>
    );
};

export default SurveysItemEditor;